/* Guide des tailles · logique reproduite de luveon.com (seuils et tableaux de la marque), 27/10/2026.
   Les valeurs saisies en pouces (US) sont converties en cm avant comparaison. */
(function () {
  var overlay = document.getElementById('luv-sg-overlay');
  if (!overlay || overlay.dataset.snoReady) return;
  overlay.dataset.snoReady = '1';
  if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
  var inches = overlay.dataset.snoUnit === 'in';
  var quizGroups = overlay.querySelectorAll('[data-luv-sg-quiz-group]');
  var tableGroups = overlay.querySelectorAll('[data-luv-sg-table-group]');
  var resultEl = document.getElementById('luv-sg-result');
  var resultSz = document.getElementById('luv-sg-result-size');
  function cm(value) { var n = parseFloat(String(value || '').replace(',', '.')); return isNaN(n) ? null : (inches ? n * 2.54 : n); }
  function sizeFromMeasures(w, h) {
    function bucket(v, isHips) {
      if (!v) return null;
      if (isHips) { if (v <= 85) return 'XS'; if (v <= 94) return 'S'; if (v <= 106) return 'M'; if (v <= 115) return 'L'; if (v <= 122) return 'XL'; if (v <= 130) return '2XL'; if (v <= 141) return '3XL'; if (v <= 150) return '4XL'; return '5XL'; }
      if (v <= 60) return 'XS'; if (v <= 69) return 'S'; if (v <= 80) return 'M'; if (v <= 89) return 'L'; if (v <= 99) return 'XL'; if (v <= 110) return '2XL'; if (v <= 120) return '3XL'; if (v <= 129) return '4XL'; return '5XL';
    }
    var bw = bucket(w, false), bh = bucket(h, true);
    var order = { XS: 0, S: 1, M: 2, L: 3, XL: 4, '2XL': 5, '3XL': 6, '4XL': 7, '5XL': 8 };
    if (bw && bh) return order[bw] >= order[bh] ? bw : bh;
    return bw || bh || null;
  }
  function sizeFromBust(b) {
    if (!b) return null;
    var t = [[83, 'XS'], [88, 'S'], [93, 'M'], [98, 'L'], [103, 'XL'], [108, '2XL'], [113, '3XL'], [118, '4XL'], [123, '5XL']];
    for (var i = 0; i < t.length; i++) if (b <= t[i][0]) return t[i][1];
    return '5XL';
  }
  function showResult(size) {
    if (!resultEl || !resultSz || !size) return;
    resultSz.textContent = size;
    resultEl.classList.add('is-visible');
  }
  function setCategory(category) {
    var active = (category && overlay.querySelector('[data-luv-sg-quiz-group="' + category + '"]')) ? category : 'legging';
    overlay.dataset.category = active;
    overlay.querySelectorAll('[data-luv-sg-hint]').forEach(function (hint) { hint.hidden = hint.dataset.luvSgHint !== (active === 'legging' ? 'legging' : 'top'); });
    quizGroups.forEach(function (g) { g.hidden = g.dataset.luvSgQuizGroup !== active; });
    tableGroups.forEach(function (g) { g.hidden = g.dataset.luvSgTableGroup !== active; });
    if (resultEl) resultEl.classList.remove('is-visible');
    if (resultSz) resultSz.textContent = '—';
  }
  function openGuide(category) {
    setCategory(category);
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeGuide() {
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  quizGroups.forEach(function (group) {
    var category = group.dataset.luvSgQuizGroup;
    var pills = group.querySelectorAll('[data-size-pill]');
    pills.forEach(function (btn) {
      btn.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        showResult(btn.dataset.size);
      });
    });
    var toggle = group.querySelector('[data-luv-sg-toggle-detail]');
    var detail = group.querySelector('[data-luv-sg-detail]');
    if (toggle && detail) toggle.addEventListener('click', function () { detail.classList.toggle('is-visible'); });
    var waistIn = group.querySelector('[data-measure="waist"]');
    var hipsIn = group.querySelector('[data-measure="hips"]');
    var bustIn = group.querySelector('[data-measure="bust"]');
    function recalc() {
      var size = (category === 'bra' || category === 'top' || category === 'tshirt')
        ? sizeFromBust(cm(bustIn && bustIn.value))
        : sizeFromMeasures(cm(waistIn && waistIn.value), cm(hipsIn && hipsIn.value));
      if (size) showResult(size);
    }
    [waistIn, hipsIn, bustIn].forEach(function (i) { if (i) i.addEventListener('input', recalc); });
  });
  var tabs = overlay.querySelectorAll('[data-luv-sg-tab]');
  var panels = overlay.querySelectorAll('[data-luv-sg-panel]');
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.luvSgTab;
      tabs.forEach(function (t) { var on = t.dataset.luvSgTab === target; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      panels.forEach(function (p) { var on = p.dataset.luvSgPanel === target; p.classList.toggle('is-active', on); if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', ''); });
    });
  });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeGuide(); });
  overlay.querySelectorAll('[data-luv-sg-close]').forEach(function (b) { b.addEventListener('click', closeGuide); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closeGuide(); });
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-luveon-size-guide]');
    if (t) { e.preventDefault(); e.stopPropagation(); openGuide(t.dataset.luvSgCategory); }
  }, true);
})();
